import { appUiSlice } from './slices/app-ui-slice';

export const appUiReducer = {
    appUi: appUiSlice.reducer,
};
